export const prot = window.location.protocol;

let appType = 1;  // PRODUKCJA
// let appType = 2; // TEST PROD
// let appType = 3; // DEV

export default class AppConfig {

    static DATE_OF_MODIFICATION() {
        return 'v1.67'
    }

    static HOST_API() {
        switch (appType) {
            case 1:
                return prot + '//api-site.marcel-bus.pl/'
            case 2:
                return prot + '//api-marcel-site.topsa.com.pl/'
                // return 'https://api-site.marcel-bus.pl/'
            case 3:
                return 'http://centos7.top:9101/'
                // return 'http://linuxdev.top:8084/'
        }
    }

    static HOST_EBUS() {
        switch (appType) {
            case 1:
                return prot + '//api-ebus.marcel-bus.pl/'
            case 2:
                return prot + '//api-marcel-ebus.topsa.com.pl/'
            case 3:
                return 'http://centos7.top:9101/'
                // return 'http://linuxdev.top:8084/'
        }
    }

    static V_LOG() {
        return '?appVersion=' + this.DATE_OF_MODIFICATION();
    }

    static V_LOG_SECOND_PARAM() {
        return '&appVersion=' + this.DATE_OF_MODIFICATION();
    }

    static TYPE() {
        switch (appType) {
            case 1:
                return 'PROD'
            case 2:
                return 'TEST PROD'
            case 3:
                return 'DEV'
        }
    }

}



// WEBPACK FOOTER //
// ./src/components/AppConfig.js